<template>
  <div>
    视频管理
  </div>
</template>

<script>
export default {
  name: 'ZuijiBridegIndex',

  data () {
    return {

    };
  },

  mounted () {

  },

  methods: {

  },
};
</script>

<style lang="scss" scoped>
</style>